import React, { Component } from "react";
import { Table, Form, Grid, Popup, Icon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import Strings from "./utilities/StringSelector";
import Constants from "./utilities/Constants";
import Utils from "./utilities/Utils";

const ipRegex = new RegExp("^[0-2][0-9.]*$");
const macRegex = new RegExp("^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$");

const UtilsInstance = new Utils();

class Topology extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      column: null,
      sortDirection: null,
      originalDevices: [],
      devices: [],
    };
  }

  // Creates a list with entries that match the IP passed on the form
  handleIPSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalDevices[i].ip === this.state.formInput) {
        searchedDevices.push(this.state.originalDevices[i]);
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  handleMacAddressSearch = () => {
    const len = this.state.originalDevices.length;
    const searchedDevices = [];

    for (let i = 0; i < len; i++) {
      // Uppercases both strings before comparison to allow search flexibility
      if (this.state.originalDevices[i].mac != null && this.state.formInput != null) {
        if (this.state.originalDevices[i].mac.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
          searchedDevices.push(this.state.originalDevices[i]);
        }
      }
    }

    if (searchedDevices.length > 0) {
      this.setState({ devices: searchedDevices });
    } else {
      this.setState({ devices: [] });
    }
  }

  /*
    Filters the page list showing only the devices that match the
    ip or name the user has typed
  */
  handleSubmit = () => {
    if (this.state.formInput !== "" && ipRegex.test(this.state.formInput)) {
      this.handleIPSearch();
    }
    else if (this.state.formInput !== "" && macRegex.test(this.state.formInput)) {
      this.handleMacAddressSearch();
    }
    else if (this.state.formInput === "") {
      this.setState({ devices: this.state.originalDevices });
    }
  }

  retrieveData = () => {
    if (this.state.formInput === "") {
      // Retrieve devices list
      fetch(Constants.REQUEST_IP_ADDRESS + "topology", { mode: "cors" })
        .then(res => res.json())
        .then((data) => {
          // Sort the devices by IP
          let devicesCopy = JSON.stringify(data);
          devicesCopy = JSON.parse(devicesCopy);

          devicesCopy = devicesCopy.sort((a, b) => {
            const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
            const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
            return num1 - num2;
          });

          // Then sort their ports alphabetically
          for (let i = 0; i < devicesCopy.length; i++) {
            devicesCopy[i].connections = devicesCopy[i].connections.sort(
              UtilsInstance.sortBy(
                "selfPort",
                false,
                function (a) { return UtilsInstance.treatUppercase(a); }
              )
            );
          }

          this.setState({
            devices: devicesCopy,
            originalDevices: devicesCopy
          });
        });
    }
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_LIVE_TOPOLOGY;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  /*
    Saves the form input to the component state everytime the user
    types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  // ----------------- Lifecycle Methods ----------------
  componentDidMount = () => {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveData, 5000) });
    this.adjustTableMaxHeight();
  }

  componentWillUnmount = () => {
    clearInterval(this.state.intervalID);
  }

  componentDidUpdate = () => {
    this.adjustTableMaxHeight();
  }

  // Render the table containing the network topology
  render() {
    const filter = this.state.formInput;

    const topologyDevices = this.state.devices.map(device => (
      <Table.Body key={device.mac}>
        <Table.Row style={mainTableRowStyle}>
          <Table.Cell>{UtilsInstance.getYesNoFromBoolean(device.topologySNMP)}</Table.Cell>
          <Table.Cell>{device.ip}</Table.Cell>
          <Table.Cell>{device.mac}</Table.Cell>
          <Table.Cell colSpan="3" />
        </Table.Row>
        {device.connections.map(connection => (
          // eslint-disable-next-line react/jsx-key
          <Table.Row>
            <Table.Cell colSpan="3" />
            <Table.Cell>{connection.selfPort}</Table.Cell>
            <Table.Cell>{connection.neighborPort}</Table.Cell>
            <Table.Cell>{connection.neighborIP}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    ));

    return (
      <div style={screenStyle}>

        <Grid columns={3} verticalAlign="middle">

          <Grid.Column textAlign="left" width={4}>
            <Popup position='bottom left' hoverable pinned wide="very"
              trigger={<Icon name="question circle" size="big" color="teal" />}>
              <Popup.Content>
                <p>{Strings.TOPOLOGY_POPUP_1}</p>
                <ul>
                  <li>{Strings.TOPOLOGY_POPUP_2}</li>
                  <li>{Strings.TOPOLOGY_POPUP_3}</li>
                </ul>
              </Popup.Content>
            </Popup >
          </Grid.Column>

          <Grid.Column width={8}>
            <Form style={searchStyle} onSubmit={this.handleSubmit} >
              <Form.Input
                id="inputform"
                placeholder={Strings.TOPOLOGY_INPUT_TEXT_PLACEHOLDER}
                icon="search"
                name="formInput"
                value={filter}
                onChange={this.handleChange} />
            </Form>
          </Grid.Column>

          <Grid.Column width={4} />

        </Grid>

        <Table id="table-header" style={headerMarginStyle} compact stackable fixed celled textAlign="center">
          <Table.Header>
            <Table.Row>
              <Popup position='bottom left' hoverable pinned wide="very"
                trigger={
                  <Table.HeaderCell>
                    {Strings.SNMP}
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  </Table.HeaderCell>
                }>
                <Popup.Content>
                  <p>{Strings.SNMP_POPUP_1}</p>
                  <ul>
                    <li><b>{Strings.YES}:</b> {Strings.SNMP_POPUP_2}</li>
                    <li><b>{Strings.NO}:</b> {Strings.SNMP_POPUP_3}</li>
                  </ul>
                </Popup.Content>
              </Popup>


              <Table.HeaderCell>{Strings.IP}</Table.HeaderCell>
              <Table.HeaderCell>{Strings.MAC}</Table.HeaderCell>
              <Table.HeaderCell>{Strings.PORT}</Table.HeaderCell>
              <Table.HeaderCell>{Strings.NEIGHBOUR_PORT_1} {Strings.NEIGHBOUR_PORT_2}</Table.HeaderCell>
              <Table.HeaderCell>{Strings.NEIGHBOUR_IP}</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table id="main-table" compact stackable fixed celled textAlign="center">
            {topologyDevices}
          </Table>
        </div>
      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  margin: "2vh 2vw",
};

const tableStyle = {
  overflowY: "scroll"
};

const headerMarginStyle = {
  marginTop: "0px",
  marginBottom: "8px",
  width: "99%"
};

const mainTableRowStyle = {
  backgroundColor: "#BDBDBD"
};

const searchStyle = {
  margin: "0 auto",
  marginTop: "8px",
  marginBottom: "16px"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default withRouter(Topology);
